
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';



let httpHeaders = new HttpHeaders()
.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
.set('Content-Type', 'application/json');   
let options = {
headers: httpHeaders
};  

const httpOptions = {
  headers: new HttpHeaders({
    'Authorization': 'Bearer ' + localStorage.getItem('token'),
    'Content-Type': 'application/json'

  })
}
@Injectable({
  providedIn: 'root'
})
export class ImportFileService {

  constructor(private http: HttpClient) { }

postFile(formdata: FormData): Observable<HttpResponse<any>> {
  console.log(formdata);
  return this.http.post<HttpResponse<any>>(environment.apiUrl + 'User/'+'SaveExcelData', formdata, {
   
    observe: 'response'
  });    
}

}
